/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { SegmentedControl, Progress, useMantineColorScheme } from '@mantine/core';
import {
  CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis,
} from 'recharts';
import {
  CurrencyDollar, TrendingUp, ChartArea, ArrowUpRight, ArrowDownRight, Plus, Minus,
} from 'tabler-icons-react';
import { renderCompactNumber, renderNumber } from '../../../utilities/general';
import {
  openPositions, recentOrders, transfersData, walletAssets,
} from '../companyData/BalanceSheet/dummy';

const portfolioData = [
  { name: 'Jan', amount: 93000 },
  { name: 'Feb', amount: 100000 },
  { name: 'Mar', amount: 96000 },
  { name: 'Apr', amount: 109000 },
  { name: 'May', amount: 116300 },
  { name: 'Jun', amount: 88000 },
];

export default function OverviewTab(props) {
  const [value, setValue] = useState('orders');
  const { colorScheme } = useMantineColorScheme();

  const stats = [
    {
      title: 'Total Portfolio Value',
      value: '$124,532.89',
      change: '+2.8%',
      icon: CurrencyDollar,
      iconBg: 'bg-[#D0FAE5]',
      iconColor: 'text-[#00BC7D]',
    },
    {
      title: 'Total P&L',
      value: '$8,234.12',
      change: '+12.4%',
      icon: TrendingUp,
      iconBg: 'bg-[#E8F3FF]',
      iconColor: 'text-[#0861C7]',
    },
    {
      title: 'Active Positions',
      value: '23',
      change: '+3',
      icon: ChartArea,
      iconBg: 'bg-[#FFF5DA]',
      iconColor: 'text-[#F0B100]',
    },
  ];
  const amountFormatter = (amount) => renderCompactNumber(amount, amount > 0 && true);
  return (
    <div>
      {/* Stats Cards */}
      <div className="grid grid-cols-3 gap-6 mb-8">
        {stats.map((stat, index) => {
          const IconComponent = stat.icon;
          return (
            <div
              key={index}
              className="bg-white dark:bg-[#26282C] rounded-2xl p-6 shadow-md transition-shadow"
            >
              <div className="flex justify-between items-start">
                <div>
                  <p className="text-gray-500 font-medium text-sm mb-2">{stat.title}</p>
                  <h2 className="text-2xl font-bold mb-2">{stat.value}</h2>
                  <div className="flex items-center text-[#009966]">
                    <ArrowUpRight color="#00BC7D" size={16} className="mr-1" />
                    <span className="text-sm font-medium">{stat.change}</span>
                  </div>
                </div>
                <div className={`${stat.iconBg} p-3 rounded-xl`}>
                  <IconComponent size={24} className={stat.iconColor} />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Main Content Grid */}
      <div className="grid grid-cols-3 gap-6 items-start">
        <div className="col-span-2 grid gap-8">
          {/* Wallet Summary - 2 columns */}
          <div className="grid gap-12 p-6 bg-white dark:bg-[#26282C] rounded-2xl shadow-md">
            <div className="flex justify-between items-center">
              <h3 className="text-base font-semibold text-[#0A0A0A] dark:text-[#898989]">Wallet Summary</h3>
              <p className="text-sm text-[#6A7282] dark:text-[#898989]">Total: $136,531.89</p>
            </div>
            <div className="overflow-y-auto">
              <div className="space-y-4">
                {walletAssets.map((asset, index) => (
                  <div key={index} className="px-4 flex bg-[#F9FAFB80] dark:bg-[#1f2023] rounded-xl items-center justify-between py-3">
                    <div className="flex items-center gap-4 flex-1">
                      <div className={`${asset.color} w-12 h-12 rounded-full flex items-center justify-center text-white font-bold`}>
                        {asset.name.charAt(0)}
                      </div>
                      <div>
                        <div className="flex items-center gap-2 mb-1">
                          <p className="font-bold text-lg text-[#101828] dark:text-[#898989]">{asset.name}</p>
                          <p className="text-base text-[#6A7282]">{asset.fullName}</p>
                        </div>
                        <p className="text-base text-[#4A5565]">{asset.amount > 0 ? renderNumber(asset.amount) : '--'}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-6">
                      <div className="flex flex-col gap-1">
                        <Progress
                          value={asset.percentage}
                          radius="md"
                          color={colorScheme === 'dark' ? '#e2e8f0' : '#0861C7'}
                          style={{ width: 120 }}
                          sx={{ backgroundColor: colorScheme === 'dark' ? '#a5b4fc33' : '#F3F4F6' }}
                        />
                        <span className="text-[#6A7282] dark:text-[#898989]">{`${renderNumber(asset.percentage)}%`}</span>
                      </div>
                      <div className="text-right">
                        <p className="font-semibold">{asset.value}</p>
                        <p className={`text-sm ${asset.change.startsWith('+') ? 'text-[#009966]' : asset.change.startsWith('-') ? 'text-[#E7000B]' : 'text-gray-500'}`}>
                          {asset.change}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* Portfolio Performance - 2 columns */}
          <div className="grid gap-[46px] bg-white dark:bg-[#26282C] pl-6 py-6 pr-9 rounded-2xl shadow-md">
            <div className="flex justify-between items-center">
              <h3 className="text-base font-semibold dark:text-[#898989]">Portfolio Performance</h3>
              <span className="text-[#009966] text-sm font-medium bg-[#ECFDF5] border border-[#A4F4CF] px-2 py-0.5 rounded-lg">
                {`+${31.1}% Total Return`}
              </span>
            </div>
            <div className="flex flex-col gap-6 pr-6">
              <div className="w-full h-full">
                <ResponsiveContainer width="99%" height={350}>
                  <LineChart
                    width={500}
                    height={200}
                    data={portfolioData}
                    // margin={{
                    //   top: 10,
                    //   right: 30,
                    //   left: 10,
                    //   bottom: 0,
                    // }}
                    margin={{
                      top: 20, right: 30, left: 20, bottom: 20,
                    }}
                  >
                    <CartesianGrid strokeDasharray="5 5" stroke={colorScheme === 'dark' ? '#334155' : '#f1f5f9'} strokeWidth={1} />
                    <XAxis tickLine={false} axisLine={false} dataKey="name" />
                    <YAxis
                      dataKey="amount"
                      tickLine={false}
                      axisLine={false}
                      tickFormatter={amountFormatter}
                      tickSize={12}
                      ticks={[0, 40000, 80000, 120000, 160000]}
                    />
                    <Line connectNulls type="monotone" dataKey="amount" stroke="#0861C7" strokeWidth={4} fill="#000" dot={{ r: 4, fill: '#0861C7' }} />
                  </LineChart>
                </ResponsiveContainer>
              </div>
              <div className="h-16 flex justify-between items-center border-t border-[#F3F4F6] dark:border-neutral-600">
                <div>
                  <p className="text-sm font-normal text-[#6A7282]">Total Return</p>
                  <p className="text-lg text-center font-bold text-[#009966]">{`+${31.1}%`}</p>
                </div>
                <div>
                  <p className="text-sm font-normal text-[#6A7282]">Total Gain</p>
                  <p className="text-lg text-center font-bold text-[#0861C7]">{renderNumber(29532, true)}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Time Period</p>
                  <p className="text-lg text-center font-bold text-[#101828] dark:text-[#898989]">6 months</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Open Positions - 1 column */}
        <div className="grid gap-8">
          <div className="flex flex-col gap-12 p-6 rounded-2xl bg-white dark:bg-[#26282C] shadow-md">
            <div>
              <h3 className="text-base font-semibold text-[#0A0A0A] dark:text-[#898989]">Open Positions</h3>
            </div>
            <div className="flex flex-col gap-4">
              {openPositions.map((position, index) => (
                <div key={index} className="h-24 border border-gray-100 dark:border-neutral-600 rounded-xl p-[17px]">
                  <div className="flex justify-between">
                    <div className="flex flex-col gap-1">
                      <div className="font-medium text-[#101828] dark:text-[#898989]">{position.pair}</div>
                      <div className="flex items-center gap-2 mb-3">
                        <span className={`text-xs font-medium px-2 py-0.5 rounded-lg ${position.type === 'Long' ? 'bg-[#030213] text-white' : 'bg-[#ECEEF2] text-[#030213]'}`}>
                          {position.type}
                        </span>
                        <span className="text-xs border border-[#A4F4CF] px-2 py-0.5 rounded-lg bg-[#ECFDF5] text-[#009966]">
                          {position.status}
                        </span>
                      </div>
                    </div>
                    <div className="flex flex-col gap-1">
                      <div className="flex items-center gap-1">
                        {position.positive ? (
                          <ArrowUpRight size={16} className="text-[#00BC7D]" />
                        ) : (
                          <ArrowDownRight size={16} className="text-[#FB2C36]" />
                        )}
                        <p className={`font-semibold ${position.positive ? 'text-[#009966]' : 'text-[#E7000B]'}`}>
                          {position.pnl}
                        </p>
                      </div>
                      <div className={`flex justify-end text-sm ${position.positive ? 'text-[#009966]' : 'text-[#E7000B]'}`}>
                        {position.change}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <div className="flex justify-center items-center">
                <span className="text-sm font-medium text-[#0861C7] cursor-pointer">View All Positions</span>
              </div>
            </div>
          </div>
          {/* Recent Activity - 1 column */}
          <div className="flex flex-col gap-12 p-6 bg-white dark:bg-[#26282C] rounded-2xl shadow-md">
            <div>
              <h3 className="text-base font-semibold text-[#0A0A0A] dark:text-[#898989]">Recent Activity</h3>
            </div>
            <div className="flex flex-col gap-6">
              <div>
                <SegmentedControl
                  styles={() => ({
                    root: {
                      backgroundColor: colorScheme === 'dark' ? '#1f2023' : '#ECECF0',
                    },
                    label: {
                      color: colorScheme === 'dark' ? '#898989' : '#0A0A0A',
                      '&:hover': {
                        color: colorScheme === 'dark' ? '#898989' : '#0A0A0A',
                      },
                    },
                  })}
                  fullWidth
                  radius="lg"
                  value={value}
                  size="sm"
                  onChange={setValue}
                  data={[
                    {
                      label: 'Orders',
                      value: 'orders',
                    },
                    {
                      label: 'Transfers',
                      value: 'transfers',
                    },
                  ]}
                />
              </div>
              <div className="flex flex-col gap-3">
                {value === 'orders' ? (
                  recentOrders.map((order, index) => (
                    <div key={index} className="h-[74px] p-3">
                      <div className="flex justify-between items-start">
                        <div className="flex flex-col gap-1">
                          <div className="text-base font-medium text-[#101828] dark:text-[#898989]">{order.pair}</div>
                          <div className="text-sm text-[#6A7282]">{order.type}</div>
                        </div>
                        <div className="flex flex-col gap-2">
                          <div className="flex justify-end text-base text-[#101828] dark:text-[#898989] font-medium">{renderNumber(order.amount, true)}</div>
                          <div className="flex items-center gap-1">
                            <div className={`text-xs px-2 py-0.5 rounded-lg ${order.status === 'Filled' ? 'bg-[#030213] text-white' : 'bg-[#ECEEF2] text-[#030213]'}`}>
                              {order.status}
                            </div>
                            <div className="text-xs text-[#6A7282]">{order.time}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  transfersData.map((items, index) => (
                    <div key={index} className="h-[72px] p-3">
                      <div className="flex justify-between">
                        <div className="flex items-center gap-3">
                          <div className={`flex items-center justify-center w-8 h-8 rounded-full ${items.amount > 0 ? 'bg-[#D0FAE5]' : 'bg-[#FFE2E2]'}`}>
                            {items.amount > 0 ? <Plus size={16} color="#009966" /> : <Minus size={16} color="#E7000B" />}
                          </div>
                          <div className="flex flex-col gap-1">
                            <p className="text-base font-medium text-[#101828] dark:text-[#898989]">{items.type}</p>
                            <p className="text-sm font-normal text-[#6A7282]">{items.source}</p>
                          </div>
                        </div>
                        <div className="flex flex-col gap-1 items-end">
                          <p className={`text-base font-medium ${items.amount > 0 ? 'text-[#009966]' : 'text-[#E7000B]'}`}>{items.source === 'Bank Account' ? renderNumber(items.amount, true) : `${renderNumber(items.amount)} ${items.pair}`}</p>
                          <p className="text-xs font-normal text-[#6A7282]">{items.time}</p>
                        </div>
                      </div>
                    </div>
                  ))
                )}
                <div className="h-full flex justify-center items-center">
                  <span className="text-sm font-medium text-[#0861C7] cursor-pointer">{`View All ${value === 'orders' ? 'Orders' : 'Transfers'}`}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
